module.exports = __webpack_public_path__ + "fonts/OpenSans-LightItalic.5a3ac4d0.ttf";